import { useState } from 'react'
import { string, func, bool, object } from 'prop-types'
import DatePicker, { registerLocale } from 'react-datepicker'
import fr from 'date-fns/locale/fr'
import en from 'date-fns/locale/en-US'
import Div from '@ui/layout/Div'
import 'react-datepicker/dist/react-datepicker.css'
import Alert from '@ui/elements/Alert'

const DateRangeType = ({
  onChange = () => { },
  onClear = () => { },
  disabled = false,
  isRequired = false,
  name,
  cssClass,
  range = { start: new Date(), end: null },
  placeholder,
  label,
  help,
  error
}) => {
  registerLocale('fr', fr)
  registerLocale('en', en)

  const [startDate, setStartDate] = useState(range.start);
  const [endDate, setEndDate] = useState(range.end);

  const formatDate = date => {
    console.log(date)
    if (date) {
      return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
    }
    return null
  }

  const sendDates = dates => {
    const [start, end] = dates
    setStartDate(start)
    setEndDate(end)
    onChange(name, { startDate: formatDate(start), endDate: formatDate(end) })
    if (null === start && null === end) {
      onClear()
    }
  }

  return (
    <Div cssClass={`field ${cssClass}`}>
      {label && <label className={`label ${isRequired ? 'is-required' : ''}`} htmlFor={`input-${name}`}>{label}</label>}
      <Div cssClass="control">
        <DatePicker
          dateFormat='dd/MM/yyyy'
          locale='fr'
          peekNextMonth
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          selected={startDate}
          startDate={startDate}
          endDate={endDate}
          selectsRange
          onChange={sendDates}
          placeholderText={placeholder}
          disabled={disabled}
          isClearable
          id={`input-${name}`}
          className='input is-primary'
        />
      </Div>
      {help && <p className="help">{help}</p>}
      {error && <Alert cssClass='clear' type='is-danger' message={error} />}
    </Div>
  )
}

DateRangeType.propTypes = {
  name: string,
  onChange: func,
  onClear: func,
  cssClass: string,
  disabled: bool,
  value: string,
  placeholder: string,
  help: string,
  label: string,
  error: string,
  isRequired: bool,
  isInline: bool,
  range: object
}

export default DateRangeType
